import React from "react";
import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import AvpHeader from "../shared/header/AvpHeader";
import { useLingueStore } from "../sistema/storeLingua";

export default function DashboardScreen() {
  const { selectedLinguaTesto } = useLingueStore(
    (state) => state
  );
  const navigate = useNavigate();
  useEffect(() => {
    if (!localStorage.getItem("token")) {
      navigate("/login");
    } else {
      //getUser();
    }
  }, []);

  return (
    <div id="avp-dashboard-screen">
      <AvpHeader selectedMenuId={"dashboard"} />
      <div id="avp-cms-screen-content">{selectedLinguaTesto?.DashboardTitle}</div>
    </div>
  );
}
